<template>
  <div>
    <div class="phone-form">
      <!-- <p class="tip-text">
        您正在进行重要操作，为保证您的数据安全，请验证您的手机号
      </p>
      <div class="form-content">
        <div class="form-item phone">
          <span class="label">手机号</span>
          <input class="input-wrap" v-model="form.phone" disabled />
        </div>
        <div class="form-item code">
          <div class="label">验证码</div>
          <div class="input-wrap">
            <input v-model="form.vercode" @blur="checkCode" />
            <span
              class="btn-code"
              :class="{ 'btn-forbid': isDisabled }"
              @click="getCode"
              >{{ codeTxt }}</span
            >
          </div>
        </div>
        <p class="error">{{ errorCodeTxt }}</p>
      </div>
      <div class="btn-confirm" @click="submitForm">确认</div> -->
      <div class="title">安全验证</div>
      <div class="box">
        <div class="code-title">为保证你的账号安全，需进行手机号验证</div>
        <div class="code-desc">
          请输入手机号+86 {{ developerInfo.phone }}上的验证码
        </div>
        <van-password-input
          :value="form.vercode"
          :focused="showKeyboard"
          :mask="false"
          @focus="showKeyboard = true"
        >
        </van-password-input>
        <!--数字键盘-->
        <van-number-keyboard
          v-model="form.vercode"
          :show="showKeyboard"
          @blur="blurKey"
        >
        </van-number-keyboard>
        <div class="bottom-desc">
          没有收到？
          <span
            class="btn-code"
            :class="{ 'btn-forbid': isDisabled }"
            @click="getCode"
            >{{ codeTxt }}</span
          >
        </div>
      </div>
    </div>
    <div class="submit-btn">
      <div class="content" @click="submitForm">确认</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getVercode, checkVercode, getKfzInfo } from '@/api/common';
//import { getVercode,getKfzInfo } from '@/api/common';
import { changePhone } from '@/api/account';
export default {
  data() {
    return {
      isDisabled: false,
      codeTxt: '获取验证码',
      errorCodeTxt: '',
      showKeyboard: false,
      withdraw_type: 1,
      descTip: '',
      showCode: false,
      form: {
        vercode: '',
        phone: '',
      },
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo', 'bankInfo']),
  },
  methods: {
    init() {
      //判断手机号码是否存在
      if (this.developerInfo.phone) {
        this.form = {
          phone: this.developerInfo.phone,
          vercode: '',
        };
      } else {
        this.form = {
          phone: '',
          vercode: '',
        };
        this.$toast.fail('请在设置中进行手机号码绑定');
        setTimeout(() => {
          this.$router.push({ name: 'AccountSettings' });
        }, 1000);
      }
    },
    // 获取公共验证码接口
    // async fetchGetVercode() {
    //   try {
    //     await getVercode({
    //       phone: this.form.phone,
    //       tk: this.userInfo.tk,
    //     });
    //     this.$Toast.success('发送成功');
    //     this.countDown();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // 获取公共验证码接口
    async fetchGetVercode(phone) {
      try {
        await getVercode({ phone, tk: this.userInfo.tk });
        this.$Toast.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    // 验证验证码
    async fetchCheckVercode() {
      try {
        await checkVercode({ vercode: this.form.vercode });
        if (this.bankInfo.bank_card) {
          //  已绑定去到显示页否则去绑定页
          this.$router.push({ name: 'bindInfo' });
        } else {
          this.$router.push({ name: 'bindForm' });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取验证码
    // getCode() {
    //   this.fetchGetVercode();
    // },
    // 获取验证码
    getCode() {
      this.fetchGetVercode(this.developerInfo.phone);
    },
    // 提交表单
    submitForm() {
      if (this.form.vercode.length) {
        if (this.developerInfo.phone) {
          this.fetchCheckVercode();
        } else {
          this.fetchBindPhone();
        }
      } else {
        this.$toast.fail('验证码不能为空');
      }
    },
    checkCode() {
      if (this.form.vercode.length) {
        this.errorCodeTxt = '';
      } else {
        this.errorCodeTxt = '验证码不能为空';
      }
    },
    //保存新号码
    async fetchKfzInfo() {
      try {
        const res = await getKfzInfo();
        this.$store.commit('SET_DEVELOPER_INFO', res.data);
      } catch (error) {
        console.log('error');
      }
    },
    //绑定手机号码
    async fetchBindPhone() {
      let data = {
        vercode: this.form.vercode,
        new_phone: this.form.phone,
        tk: this.userInfo.tk,
      };
      try {
        await changePhone(data);
        //this.$Toast.success('操作成功');
        this.fetchKfzInfo();
        this.$router.push({ name: 'bindForm' });
      } catch (error) {
        console.log(error);
      }
    },
    // 倒计时
    countDown() {
      let time = 60;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '重新发送';
        }
      }, 1000);
    },
    blurKey() {
      this.showKeyboard = false;
    },
  },
};
</script>

<style lang="less" scoped>
.phone-form {
  // font-size: 24px;
  color: #262626;
  width: 100%;
  // min-height: calc(100vh - 103px);
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 38px;
    margin-top: 20px;
  }
  .box {
    width: 710px;
    height: auto;
    overflow: hidden;
    background: #ffffff;
    border-radius: 8px;
    padding-bottom: 17px;
    .code-title {
      padding: 41px 49px 26px 49px;
      color: #262626;
      font-size: 34px;
    }
    .code-desc {
      width: 100%;
      text-align: center;
      color: #8c8c8c;
      font-size: 28px;
      margin-bottom: 65px;
    }
    .bottom-desc {
      width: 100%;
      //  display: flex;
      margin-top: 90px;
      text-align: center;
      color: #8c8c8c;
      font-size: 24px;
      .btn-code {
        color: #2b6ddfff;
      }
    }
  }
  /deep/.van-number-keyboard {
    margin-top: 300px;
  }
}
.submit-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 90px;
  .content {
    width: 360px;
    height: 90px;
    background: #fd9b21;
    border-radius: 8px;
    color: #ffffff;
    text-align: center;
    font-size: 32px;
    padding-top: 23px;
  }
}
input {
  -webkit-appearance: none;
}
</style>
<style lang="less" scoped>
::v-deep .van-password-input__security {
  .van-password-input__item::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    top: -50%;
    right: -50%;
    bottom: -50%;
    left: -50%;
    border: 0 solid #ebedf0;
    -webkit-transform: scale(.5);
    transform: scale(.5);
    width: 128px;
    border: none;
    border-bottom: 6px solid rgba(151, 151, 151, 0.39);
    margin: auto;
  }
}
.van-hairline--surround::after {
  border: none;
}
</style>
